import React, { FunctionComponent } from 'react'
import { AccountTabs } from '../AccountTabs'
import { Heading, Icon, Panel, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import { useConsumerName, useConsumerCreatedYear, useConsumerCreatedMonthByLocale, useConsumerIdentityStatus } from '../../state'
import { useConsumerSizes } from '../../utils/responsive'
import { IdentityCheckStatus } from '../../model'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { ExtendedPanel } from '../Panel'

const I18N_NAMESPACE = ['common', 'account']

export const AccountPanel: FunctionComponent = () => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation(I18N_NAMESPACE)
  const { headingSize } = useConsumerSizes()
  const consumerName = useConsumerName()
  const consumerCreatedYear = useConsumerCreatedYear()
  const consumerCreatedMonth = useConsumerCreatedMonthByLocale(locale)
  const consumerIdentityStatus = useConsumerIdentityStatus()

  return (
    <Panel>
      <ExtendedPanel.HeadWithCrumb>
        <div className='flex flex-col'>
          <div className='flex flex-wrap items-center gap-x-4'>
            <MaskedElement>
              <Heading bold size={headingSize}>
                {consumerName}
              </Heading>
            </MaskedElement>
            {consumerIdentityStatus === IdentityCheckStatus.VERIFIED && (
              <span className='flex items-center gap-x-2'>
                <Icon name='Verified' size='Medium' />
                <Text size='S'>{t('account:verified')}</Text>
              </span>
            )}
          </div>
          <Text>{`${t('account:subtitle')} ${consumerCreatedMonth} ${consumerCreatedYear.toString()}`}</Text>
        </div>
      </ExtendedPanel.HeadWithCrumb>
      <Panel.Content inset>
        <AccountTabs />
      </Panel.Content>
    </Panel>
  )
}
